import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminUserPlusIcon = (props: IconProps) => (
  <Icon width="26px" height="26px" viewBox="0 0 26 26" {...props}>
    <path d="M14.083 8.667A4.332 4.332 0 0 0 9.75 4.333a4.332 4.332 0 0 0-4.334 4.334A4.332 4.332 0 0 0 9.75 13a4.332 4.332 0 0 0 4.333-4.333Zm-2.167 0a2.173 2.173 0 0 1-2.166 2.166 2.173 2.173 0 0 1-2.167-2.166c0-1.192.975-2.167 2.167-2.167 1.191 0 2.166.975 2.166 2.167ZM1.083 19.5v2.167h17.333V19.5c0-2.882-5.774-4.333-8.666-4.333-2.893 0-8.667 1.451-8.667 4.333Zm2.167 0c.216-.77 3.575-2.167 6.5-2.167 2.914 0 6.261 1.387 6.5 2.167h-13Zm18.416-3.25V13h3.25v-2.167h-3.25v-3.25H19.5v3.25h-3.25V13h3.25v3.25h2.166Z" />
  </Icon>
);

export default memo(AdminUserPlusIcon);
